<template>
  <div class="" v-if="creditNote">
    <TopBarTitleComponent
      title="Información Nota de Crédito"
      :showBackIcon="true"
    >
      <template slot="right-area">
        <div class="d-flex justify-content-end align-items-center">
          <el-dropdown
            @command="handleCommand"
            class="dropdown-theme-gray-outline d-flex align-items-center mr-4"
          >
            <span class="el-dropdown-link">
              <span class="ml-2">Opciones</span>
              <i class="el-icon-arrow-down el-icon--right mr-2"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <template
                v-if="
                  creditNote.status === 'draft' ||
                    creditNote.status === 'failed'
                "
              >
                <el-dropdown-item command="credit-note-edit">
                  <img :src="iconEdit" alt="" /> Editar</el-dropdown-item
                >
              </template>

              <el-dropdown-item command="credit-note-send">
                <img :src="iconSend" alt="" /> Enviar
                documento</el-dropdown-item
              >
              <template>
                <el-dropdown-item
                  v-if="creditNote.status == 'success'"
                  command="credit-note-nuled"
                  ><img :src="iconNuled" alt="" /> Anular</el-dropdown-item
                >
              </template>
              <el-dropdown-item command="credit-note-download"
                ><img :src="iconDownload" alt="" /> Descargar
                PDF</el-dropdown-item
              >
              <el-dropdown-item
                v-if="
                  creditNote.status !== 'success' &&
                    creditNote.status !== 'nuled'
                "
                command="credit-note-delete"
              >
                <img :src="iconDelete" alt="" /> Eliminar
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <ButtonPrimaryComponent
            v-if="
              creditNote.status !== 'success' && creditNote.status !== 'nuled'
            "
            title="Firmar"
            @onSaveClick="toogleModalDocumentSRI"
          />
        </div>
      </template>
    </TopBarTitleComponent>
    <b-container fluid class="pb-4 px-lg-4 pt-4">
      <b-row v-if="creditNote.sri_sign_message">
        <b-col>
          <AlertInfoComponent
            title="Notificación SRI"
            type="error"
            class="mb-4"
            :description="creditNote.sri_sign_message"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="card box-shadow card-quotes-view py-4">
            <div class="card-body">
              <div class="card-quotes-view-header">
                <!-- Mobile header -->
                <DocumentViewHeader
                  class="d-block d-md-none"
                  doc-type="Nota de crédito"
                  :doc-number="creditNote.identification_document"
                  :business="{
                    logo: getUser.user_business.business_logo,
                    name: getUser.user_business.social_reason,
                    ruc: getUser.user_business.business_ruc
                  }"
                  :date="creditNote.emission_date_for_view"
                  :status="creditNote.status"
                  :client="{
                    name: creditNote.invoice.client.name,
                    document: creditNote.invoice.client.document,
                    email: creditNote.invoice.client.email
                  }"
                  :access-key="creditNote.access_key"
                  :sign-mode="creditNote.sign_mode"
                  :meta-items="[
                    {
                      label: 'Doc. modificado',
                      value: creditNote.invoice.number_invoice
                    }
                  ]"
                />

                <!-- Desktop header -->
                <b-row class="d-none d-md-flex">
                  <b-col sm="12" md="12" lg="6">
                    <div class="card-quotes-view-logo mb-4">
                      <b-row>
                        <b-col sm="12" md="5" lg="4">
                          <div class="logo">
                            <img
                              v-if="getUser.user_business.business_logo"
                              :src="getUser.user_business.business_logo"
                              class="image"
                              id="image-business"
                              alt="Empresa"
                              style="width: 100%; max-width: 200px; height: auto;"
                            />
                          </div>
                        </b-col>
                        <b-col sm="12" md="7" lg="8">
                          <div class="info">
                            <h4 class="h4 font-bold m-0">
                              N° {{ creditNote.identification_document }}
                            </h4>
                            <p class="font-semi-bold mt-2">
                              RUC: {{ getUser.user_business.business_ruc }}
                            </p>
                            <p class="font-semi-bold">
                              {{ getUser.user_business.business_address }}
                            </p>
                            <SignAuthorizationInfo
                              class="mt-4"
                              :accessKey="creditNote.access_key"
                              :signMode="creditNote.sign_mode"
                            />
                          </div>
                        </b-col>
                      </b-row>
                    </div>
                  </b-col>
                  <b-col sm="12" md="12" lg="6">
                    <div class="card-quotes-view-info">
                      <b-row>
                        <b-col sm="4" md="4" lg="4">
                          <label class="font-semi-bold d-block"
                            >Fecha de emisión</label
                          >
                          <p class="m-0">
                            {{ creditNote.emission_date_for_view }}
                          </p>
                        </b-col>
                        <b-col sm="4" md="4" lg="4">
                          <label class="font-semi-bold d-block"
                            >Documento modificar</label
                          >
                          <p class="m-0">
                            {{ creditNote.invoice.number_invoice }}
                          </p>
                        </b-col>
                        <b-col sm="4" md="4" lg="4">
                          <label class="font-semi-bold d-block mb-2"
                            >Status</label
                          >
                          <StatusReadDocumentsComponent
                            :status.sync="creditNote.status"
                          />
                        </b-col>
                      </b-row>
                      <b-row class="mt-4">
                        <b-col sm="4" md="4" lg="4">
                          <label class="font-semi-bold d-block">Cliente</label>
                          <p class="m-0">
                            {{ creditNote.invoice.client.name }}
                          </p>
                        </b-col>
                        <b-col sm="4" md="4" lg="4">
                          <label class="font-semi-bold d-block"
                            >Documento</label
                          >
                          <p class="m-0">
                            {{ creditNote.invoice.client.document }}
                          </p>
                        </b-col>
                        <b-col sm="4" md="4" lg="4">
                          <label class="font-semi-bold d-block">Correo</label>
                          <p class="m-0">
                            {{ creditNote.invoice.client.email }}
                          </p>
                        </b-col>
                      </b-row>
                    </div>
                  </b-col>
                </b-row>
              </div>
              <div class="card-quotes-view-body mt-5">
                <div class="card-quotes-view-body-products">
                  <!-- Desktop items -->
                  <div class="d-none d-md-block">
                    <div class="card-quotes-view-table table-items">
                      <b-row class="table-items-header">
                        <b-col xs="12" sm="12" md="1">
                          <h6 class="h6 font-bold mb-0 ml-2">Código</h6>
                        </b-col>
                        <b-col xs="12" sm="12" md="5">
                          <h6 class="h6 font-bold mb-0">Detalle</h6>
                        </b-col>
                        <b-col xs="12" sm="4" md="2">
                          <h6 class="h6 font-bold mb-0">Cantidad</h6>
                        </b-col>
                        <b-col xs="12" sm="4" md="2">
                          <h6 class="h6 font-bold mb-0">Precio U.</h6>
                        </b-col>
                        <b-col xs="12" sm="4" md="2">
                          <h6 class="h6 font-bold mb-0">Subtotal</h6>
                        </b-col>
                      </b-row>
                    </div>

                    <b-row
                      class="mt-4 d-flex"
                      v-for="(product, index) in creditNote.products"
                      :key="index"
                    >
                      <b-col xs="12" sm="12" md="1">
                        <p class="m-0 ml-2">{{ product.product.code }}</p>
                      </b-col>
                      <b-col xs="12" sm="12" md="5">
                        <p class="m-0">
                          <strong>{{ product.product.name }}</strong> <br />
                          <br />
                          <span
                            v-html="product.product_detail"
                            class="text-pre-wrap"
                          ></span>
                        </p>
                      </b-col>
                      <b-col xs="12" sm="4" md="2">
                        <p class="m-0">{{ product.product_quantity }}</p>
                      </b-col>
                      <b-col xs="12" sm="4" md="2">
                        <p class="m-0">${{ product.product_amount }}</p>
                      </b-col>
                      <b-col xs="12" sm="4" md="2">
                        <p class="m-0">
                          ${{
                            handleCalculateSubTotal(
                              product.product_quantity,
                              product.product_amount
                            )
                          }}
                        </p>
                      </b-col>
                    </b-row>
                  </div>
                  <!-- Mobile items -->
                  <div class="d-block d-md-none doc-mobile-items">
                    <div
                      v-for="(product, index) in creditNote.products"
                      :key="'m' + index"
                      class="doc-item"
                    >
                      <div class="doc-item-row">
                        <span class="doc-item-name">{{
                          product.product.name
                        }}</span>
                        <span class="doc-item-total"
                          >${{
                            handleCalculateSubTotal(
                              product.product_quantity,
                              product.product_amount
                            )
                          }}</span
                        >
                      </div>
                      <div v-if="product.product.code" class="doc-item-sku">
                        SKU: {{ product.product.code }}
                      </div>
                      <div class="doc-item-qty">
                        Cant: {{ product.product_quantity }} × ${{
                          product.product_amount
                        }}
                      </div>
                      <div
                        v-if="product.product_detail"
                        v-html="product.product_detail"
                        class="doc-item-detail text-pre-wrap"
                      ></div>
                    </div>
                  </div>
                </div>

                <!-- Mobile: totals -->
                <div class="d-block d-md-none">
                  <DocumentCalculatorNotes
                    :setProducts="creditNote.products"
                    :setServ="creditNote.invoice.service"
                  />
                </div>

                <hr class="d-none d-md-block" />
                <!-- Desktop: totals -->
                <b-row class="d-none d-md-flex">
                  <b-col xs="12" sm="12" md="6"></b-col>
                  <b-col xs="12" sm="12" md="4" offset-md="2">
                    <DocumentCalculatorNotes
                      :setProducts="creditNote.products"
                      :setServ="creditNote.invoice.service"
                    />
                  </b-col>
                </b-row>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <el-dialog
      width="35%"
      title=""
      :visible.sync="creditNoteSRIOuterVisible"
      class=""
    >
      <div class="wrapper__invoice-signature">
        <h4 class="h4 text-center font-semi-bold text-break text-color-primary">
          ¿Desea firmar y enviar el documento al SRI?
        </h4>
        <div class="d-flex justify-content-center align-items-center mt-5">
          <button type="button" class="btn md__btn-third-secondary mr-4">
            Cancelar
          </button>
          <ButtonPrimaryComponent
            title="Confirmar"
            @onSaveClick="sendCreditNoteSRI"
          />
        </div>
      </div>
    </el-dialog>

    <el-dialog
      width="35%"
      title=""
      :visible.sync="creditNoteDeleteOuterVisible"
      class=""
    >
      <div class="wrapper__invoice-delete text-center">
        <img :src="icoNotifyDanger" alt="ico danger" width="30" />
        <h4 class="h4 font-semi-bold text-break text-color-primary mt-4">
          ¿Seguro desea eliminar la nota de crédito?
        </h4>

        <p class="text-color-primary text-break">
          Recuerde que solo puede eliminar las notas de crédito en borrador.
        </p>

        <div class="d-flex justify-content-center align-items-center mt-4">
          <button
            @click="toggleModalCreditNoteDelete"
            class="btn md__btn-secondary mr-4"
          >
            Cancelar
          </button>
          <ButtonPrimaryComponent
            title="Eliminar"
            @onSaveClick="onCreditNoteDelete"
          />
        </div>
      </div>
    </el-dialog>

    <el-dialog
      width="35%"
      title=""
      :visible.sync="creditNoteNuledOuterVisible"
      class=""
    >
      <div class="wrapper__invoice-nuled text-center">
        <img :src="icoNotifyDanger" alt="ico danger" width="30" />
        <h4 class="h4 font-semi-bold text-break text-color-primary mt-4">
          ¿Seguro desea anular la nota de crédito?
        </h4>

        <p class="text-color-primary">
          Para completar todo el proceso de anulación la nota de crédito debe
          ser anulada en el
          <LinkSRI />
        </p>

        <div class="d-flex justify-content-center align-items-center mt-4">
          <button
            @click="toggleModalCreditNoteNuled"
            class="btn md__btn-secondary mr-4"
          >
            Cancelar
          </button>
          <ButtonPrimaryComponent
            title="Anular"
            @onSaveClick="onCreditNoteNuled"
          />
        </div>
      </div>
    </el-dialog>

    <WrapperSendDocumentDrawer
      @onDocumentSend="onDocumentSend"
      @onCloseDrawer="onCloseDocumentSendDrawer"
      :visibleDocumentSend="visibleDocumentSend"
      :toMails="toMails"
      :toPhone="toPhone"
      :clientId="
        creditNote && creditNote.invoice && creditNote.invoice.client
          ? creditNote.invoice.client.id
          : null
      "
      :recipientName="
        creditNote && creditNote.invoice && creditNote.invoice.client
          ? creditNote.invoice.client.name
          : ''
      "
      :messageableType="'credit-note'"
      :messageableId="$route.params.id"
      :moduleType="'credit-note'"
      :draftKey="'draft-creditnote-' + $route.params.id"
    />
  </div>
</template>

<script>
import AlertInfoComponent from "@/components/Alerts/Info";
import TopBarTitleComponent from "../../../../components/TopBarTitle";
import creditNoteService from "../services/creditNoteService";
import ButtonPrimaryComponent from "../../../../components/ButtonPrimary";
import StatusReadDocumentsComponent from "../../../../components/StatusReadDocuments";
import SignAuthorizationInfo from "../../../components/SignAuthorizationInfo";
import DocumentViewHeader from "../../../components/DocumentViewHeader";
import DocumentCalculatorNotes from "../../../components/DocumentCalculatorNotes";
import WrapperSendDocumentDrawer from "../../../../components/WrapperSendDocumentDrawer";
import LinkSRI from "@/components/General/LinkSRI";

import { parseFloatFormat } from "@/assets/utils/format";
import { downloadFile } from "@/assets/utils/files";
import { signingEventBus } from "@/services/signingEventBus";
import {
  icoNotifyDanger,
  iconEdit,
  iconSend,
  iconDownload,
  iconDelete,
  iconNuled
} from "@/services/resources";

export default {
  name: "CreditNoteViewPage",
  data: () => ({
    icoNotifyDanger,
    iconDelete,
    iconNuled,
    iconEdit,
    iconSend,
    iconDownload,
    creditNoteSRIOuterVisible: false,
    creditNoteDeleteOuterVisible: false,
    creditNoteNuledOuterVisible: false,
    creditNote: null,
    visibleDocumentSend: false
  }),
  computed: {
    getUser() {
      return this.$store.getters.getUser;
    },
    toMails() {
      const { client } = this.creditNote.invoice;
      if (client && client.email) return [client.email];
      return [];
    },
    toPhone() {
      const { client } = this.creditNote.invoice;
      if (client && client.phone) return String(client.phone).trim();
      return "";
    }
  },
  methods: {
    toggleModalCreditNoteNuled() {
      this.creditNoteNuledOuterVisible = !this.creditNoteNuledOuterVisible;
    },
    handleCalculateSubTotal(quantity, price) {
      return parseFloatFormat(quantity * price);
    },
    goPage(name) {
      this.$router.push({ name });
    },
    toogleModalDocumentSRI() {
      this.creditNoteSRIOuterVisible = !this.creditNoteSRIOuterVisible;
    },
    async onCreditNoteNuled() {
      try {
        this.$store.dispatch("toggleRequestLoading");
        const { id: creditNoteId } = this.creditNote;
        let response = await creditNoteService
          .updateCreditNoteStatusNuled({
            user_business_credit_note_id: creditNoteId
          })
          .finally(() => {
            this.$store.dispatch("toggleRequestLoading");
            this.toggleModalCreditNoteNuled();
          });
        const { success, data, message } = response.data;
        if (success) {
          this.creditNote = data;
          this.$notifications.success({
            message
          });
        }
      } catch (error) {
        return false;
      }
    },
    async sendCreditNoteSRI() {
      const docId = this.creditNote.id;
      const clientName = this.creditNote.client
        ? this.creditNote.client.name
        : "";
      const documentNumber = this.creditNote.number_credit_note || "";

      this.toogleModalDocumentSRI();

      signingEventBus.$emit("signing:start", {
        id: docId,
        clientName,
        documentNumber: `N. Crédito ${documentNumber}`
      });

      try {
        let response = await creditNoteService.sendCreditNoteSRI({
          user_business_credit_note_id: docId
        });
        const { success, message, data } = response.data;
        if (success) {
          signingEventBus.$emit("signing:done", {
            id: docId,
            clientName,
            documentNumber: `N. Crédito ${documentNumber}`
          });
        } else {
          signingEventBus.$emit("signing:error", {
            id: docId,
            message: message || "Error al firmar"
          });
        }
        this.creditNote = data;
      } catch (error) {
        signingEventBus.$emit("signing:error", {
          id: docId,
          message:
            error?.response?.data?.message ||
            error?.message ||
            "Error al firmar"
        });
        return false;
      }
    },
    async getCreditNoteId(creditNoteId) {
      this.$store.dispatch("toggleRequestLoading");
      try {
        let response = await creditNoteService
          .getCreditNoteId(creditNoteId)
          .finally(() => {
            this.$store.dispatch("toggleRequestLoading");
          });
        const { success, data } = response.data;
        if (success) {
          this.creditNote = data;
        }
      } catch (error) {
        return false;
      }
    },
    async onCreditNoteDelete() {
      try {
        this.$store.dispatch("toggleRequestLoading");
        const { id: creditNoteId } = this.creditNote;
        let response = await creditNoteService
          .deleteCreditNoteId(creditNoteId)
          .finally(() => {
            this.$store.dispatch("toggleRequestLoading");
            this.toggleModalCreditNoteDelete();
          });
        const { success, message } = response.data;
        if (success) {
          this.$notifications.success({
            message
          });
          this.goPage("sales.documents");
        }
      } catch (error) {
        return false;
      }
    },
    handleCommand(command) {
      switch (command) {
        case "credit-note-edit":
          this.goPage("sales.creditNote.edit", {
            id: this.creditNote.id
          });
          break;
        case "credit-note-send":
          this.visibleDocumentSend = true;
          break;
        case "credit-note-nuled":
          this.toggleModalCreditNoteNuled();
          break;
        case "credit-note-delete":
          this.toggleModalCreditNoteDelete();
          break;
        case "credit-note-download":
          this.creditNoteDownload();
          break;
      }
    },
    toggleModalCreditNoteDelete() {
      this.creditNoteDeleteOuterVisible = !this.creditNoteDeleteOuterVisible;
    },
    onDocumentSend({ data }) {
      data.append("credit_note_id", this.creditNote.id);

      this.sendCreditNoteMail({ data });
    },
    async sendCreditNoteMail({ data }) {
      const emailId = `email-creditnote-${Date.now()}`;
      const clientName = this.creditNote?.invoice?.client?.name || "";
      const docNumber = this.creditNote?.identification_document || "";

      this.visibleDocumentSend = false;

      signingEventBus.$emit("email:start", {
        id: emailId,
        clientName,
        documentNumber: `Nota de Crédito #${docNumber}`
      });

      try {
        let response = await creditNoteService.sendCreditNoteMail({ data });
        const { success, message } = response.data;
        if (success) {
          signingEventBus.$emit("email:done", {
            id: emailId,
            clientName,
            documentNumber: `Nota de Crédito #${docNumber}`
          });
        } else {
          signingEventBus.$emit("email:error", {
            id: emailId,
            message: message || "Error al enviar el documento"
          });
        }
      } catch (error) {
        signingEventBus.$emit("email:error", {
          id: emailId,
          message:
            error?.response?.data?.message ||
            error?.message ||
            "Error al enviar"
        });
      }
    },
    async creditNoteDownload() {
      this.$store.dispatch("toggleRequestLoading");
      try {
        const { identification_document, id } = this.creditNote;
        let response = await creditNoteService
          .creditNoteDownload({
            id
          })
          .finally(() => {
            this.$store.dispatch("toggleRequestLoading");
          });
        const { data } = response;
        if (data) {
          downloadFile(data, `NotaCredito - #${identification_document}`);
        }
      } catch (error) {
        return false;
      }
    },
    onCloseDocumentSendDrawer() {
      this.visibleDocumentSend = false;
    }
  },
  components: {
    TopBarTitleComponent,
    AlertInfoComponent,
    ButtonPrimaryComponent,
    StatusReadDocumentsComponent,
    SignAuthorizationInfo,
    DocumentViewHeader,
    DocumentCalculatorNotes,
    WrapperSendDocumentDrawer,
    LinkSRI
  },
  mounted() {
    const { id: creditNoteId } = this.$route.params;
    if (creditNoteId) {
      this.getCreditNoteId(creditNoteId);
    }
  }
};
</script>

<style lang="scss" scoped>
.card-quotes-view {
  .card-quotes-view-header {
    .card-quotes-view-logo {
      p {
        margin: 0;
      }
    }
  }
  .card-quotes-view-body-products {
    min-height: 300px;
  }
}
</style>
